// extracted by mini-css-extract-plugin
export default {"renewConsentButton":"styles_renewConsentButton__KY87k"};